/**
 * @file コンポーネント：フル動画ページ症例データの言語プルダウン ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// 関数読み込み
import {
    fnGetUrlVideo,
    fnGetCultureLanguage,
    fnHandleApiErrors,
    fnHandleApiSuccess,
    fnSetCookie,
    changeLanguagePath,
} from "~/src/functions/common";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const SelectLanguage = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;
    // 選択言語
    const languageCode = fnGetCultureLanguage();

    /**
     * 言語切り替え時の処理
     */
    const fnChangeSelect = (e) => {
        // 表示中の言語と異なる言語が選択された場合のみ処理
        const lang = e.target.value ;
        if (languageCode !== lang) {
            // カルチャー言語切り替えAPI処理
            const api = "/api/users/languages";
            const params = { languageCode: lang };
            const options = {
                body: JSON.stringify(params),
                headers: {
                    "Content-Type": "application/json",
                    RequestVerificationToken: document
                        .getElementById("requestverificationtoken")
                        .getAttribute("value"),
                },
                method: "PUT",
            };
            if (window.dataUser.isLogin === true) {
            fetch(api, options)
                .then(fnHandleApiErrors)
                .then(fnHandleApiSuccess)
                .then((result) => {
                    if (result !== null) {
                        // 成功時、cookieに値をセットしてリロード
                        const value = "c%3Dja%7Cuic%3D" + lang;
                        fnSetCookie(".AspNetCore.Culture", value, 7, "/");
                        // URL を言語別に変更
                        const newPath = changeLanguagePath(location.pathname, lang);
                        // クエリ・ハッシュも維持したい場合
                        location.href = newPath + location.search + location.hash;
                    }
                })
                .catch((error) => {
                    console.error(error);
                    // エラー時、アラートを出す
                    alert(localized["ErrorMessage.FailChangeLanguage"]);
                });
            }
            else {
                const value = "c%3Dja%7Cuic%3D" + lang;
                fnSetCookie(".AspNetCore.Culture", value, 7, "/");
                // URL を言語別に変更
                const newPath = changeLanguagePath(location.pathname, lang);
                // クエリ・ハッシュも維持したい場合
                location.href = newPath + location.search + location.hash;
            }
        }
    };

    // Presenterに渡す
    return (
        <Presenter
            fnChangeSelect={fnChangeSelect}
            languageCodeOperation={props.languageCodeOperation}
            listLanguage={props.listLanguage}
        />
    );
};
